import { render } from "./MyWork.vue?vue&type=template&id=2b858ae2&scoped=true"
import script from "./MyWork.vue?vue&type=script&lang=js"
export * from "./MyWork.vue?vue&type=script&lang=js"

import "./MyWork.vue?vue&type=style&index=0&id=2b858ae2&scoped=true&lang=css"
import "./MyWork.vue?vue&type=style&index=1&id=2b858ae2&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b858ae2"]])

export default __exports__